import { Fragment, useState, useEffect } from "react";

// import { AiOutlineDoubleRight, AiOutlineControl } from "react-icons/ai";
import { Popover, Form, Checkbox, Divider, Button, Tooltip, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setDashboardSetting } from "Components/Dashboard/dashboardSlice";
import { useQueryClient } from "react-query";
import AutoRefresh from "Components/Shared/AutoRefresh";
import ReFresh from "Components/Shared/Refresh";
import { SettingOutlined } from "@ant-design/icons";
import ChartList from "Components/Dashboard/Components/ChartList";
import { Navigate } from "react-router";

export interface PieProps {
  deviceStatistic?: any;
  deviceStatus?: any;
  loading: boolean;
}

const Dashboard = () => {
  const { stateCid, level } = useAppSelector((state) => state.global);
  const { dashboardSetting } = useAppSelector((state) => state.dashboard);
  const disp = useAppDispatch();
  const { t } = useTranslation();
  const [BtnVisible, setBtnVisible] = useState(false);
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  form.setFieldsValue(dashboardSetting);

  const onFinish = (value: any) => {
    disp(setDashboardSetting(value));
    localStorage.setItem("DashboardSetting", JSON.stringify(value));
    queryClient.invalidateQueries(["status", stateCid]);
    setBtnVisible(false);
  };

  // Dashboard(儀表板 圖表顯示設定)
  const content = (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item name="health" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.DevicesHealth")}</Checkbox>
      </Form.Item>
      <Form.Item name="strength" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.DevicesStrength")}</Checkbox>
      </Form.Item>
      <Form.Item name="model" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.Model")}</Checkbox>
      </Form.Item>
      <Form.Item name="firmware" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.Firmware")}</Checkbox>
      </Form.Item>
      <Form.Item name="IoT" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.IoTFlow")}</Checkbox>
      </Form.Item>
      <Form.Item name="map" valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox>{t("ISMS.Map")}</Checkbox>
      </Form.Item>
      <Divider style={{ marginBottom: "10px", marginTop: 0 }} />
      <Form.Item style={{ marginBottom: 0 }}>
        <Button
          onClick={() => {
            form.submit();
          }}
        >
          {t("ISMS.Confirm")}
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <Fragment>
      <div
        style={{
          height: "2.3rem",
          marginBottom: 0,
          marginTop: "-3px",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        {/* 自動刷新頁面 與 單次刷新頁面 儀錶板顯示設定 */}
        <Space size={1}>
          <Tooltip title={t("ISMS.Refresh")}>
            <ReFresh queriesArray={["statistic", "status", "identity"]} />
          </Tooltip>

          <AutoRefresh queriesArray={["statistic", "status", "identity"]} />

          {/* Dashboard 頁面的 設定按鈕 主要用途選取 Dashboard 顯示的資訊圖 */}
          <Tooltip title={t("ISMS.Setting")}>
            <Popover
              placement="left"
              content={content}
              trigger="click"
              onVisibleChange={(visible) => setBtnVisible(visible)}
              visible={BtnVisible}
            >
              <Button icon={<SettingOutlined />}></Button>
            </Popover>
          </Tooltip>
        </Space>
      </div>

      <ChartList />
    </Fragment>
  );
};

export default Dashboard;
